export class WebsiteConstants {
    public static SiteTitle: string = "Lingayat Reshimgathi";
    public static SiteUrl: string = "https://www.lingayathreshimgathi.com/";
    public static MasterUrl: string = "https://www.lingayathreshimgathi.com/webmaster/";
}
